import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import AffichageInfoCoach from './affichageInfoCoach';
import AffichageInfoJoueur from './affichageInfoJoueur';
import AffichageInfoArbitre from './affichageInfoArbitre';

function AffichageEquipeInfo(props) {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [equipe, setEquipe] = useState();
  const { id } = useParams();
  const { type } = useParams();
  const apiUrl = process.env.REACT_APP_API_URL;


  useEffect(() => {
    setIsLoading(true);
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${apiUrl}/recherche/equipe-arbitre`,
          {
            type: type,
            id_user: id
          },
          {
            withCredentials: true // Permet de transmettre les cookies avec la requête
          }
        );
        setEquipe(response.data);
        setError(null);
        setIsLoading(false);
      } catch (error) {
        if (error.response) {
          setError(error.response.data.message);
        } else {
          setError(true);
        }
        setIsLoading(false);
      }
    };

    fetchData();
  }, [id, type, props.userData, apiUrl]);

  if (isLoading) {
    return (
      <div className="centered-content">
        <img src="/img/logo.png" alt="Logo" className="centered-logo" />
        <br />
        <span className="loader"></span>
      </div>
    );
  }

  return (
    <>
      {error && (
        <div id="alert-message" className="alert4">
          <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
        </div>
      )}
      {props.userData ? (
        <>
          {equipe && equipe.joueur && (
            <AffichageInfoJoueur equipe={equipe} userData={props.userData} type={props.type} />
          )}

          {equipe && equipe.coach && (
            <>
              <AffichageInfoCoach equipe={equipe} userData={props.userData} type={props.type} />
            </>
          )}
          {equipe && equipe.arbitre && (
            <>
              <AffichageInfoArbitre equipe={equipe} userData={props.userData} type={props.type} />
            </>
          )}
        </>
      ) : (
        <div id="alert-message" className="alert">
          <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
        </div>
      )}
    </>
  );
}

export default AffichageEquipeInfo;
